module.exports = __webpack_public_path__ + "static/media/CTLI_13-293w.059fd5d3.jpg";